import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BPSpreadData } from '../../models/auction';
import { EditReserveCreditDialogComponent } from '../dialog/edit-reserve-credit-dialog.component';
import { take } from 'rxjs';

@Component({ standalone: false,
  selector: 'bp-spread-tooltip',
  templateUrl: './bp-spread-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bp-spread-tooltip.component.scss']
})
export class BPSpreadTooltipComponent implements OnInit {

  bpSpreadData!:BPSpreadData;
  left: number = 0;
  top: number = 0;

  constructor(private dialog:MatDialog) {}

  ngOnInit(): void {}

  public onEditReserveCreditClicked() {
    this.reserveCreditDialog();
  }

  private reserveCreditDialog(){
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data={bpSpreadData:this.bpSpreadData};
      dialogConfig.minWidth = '400px';
      this.dialog.open(EditReserveCreditDialogComponent,  dialogConfig).afterClosed().pipe(take(1)).subscribe((value)=>{
        //nothing for now
      });
  }

}